import { UpdateLoanRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';
import { UpdateLoanCrossFieldParser } from './UpdateLoanCrossFieldParser';

export const validateUpdateLoan = makeValidator({
  FieldParser: UpdateLoanRow,
  CrossFieldParser: UpdateLoanCrossFieldParser,
});
